import { combineReducers } from "redux";
import dialog from "./dialog.js";
import user from "./user.js";
import cases from "./cases.js";
import snackbar from "./snackbar.js";
import alert from "./alert.js";

const reducerList = combineReducers({
  user,
  cases,
  snackbar,
  alert,
  dialog,
});
export default reducerList;
